import React, { useCallback, useState } from "react";
import { Spinner, Tag, Tooltip } from "@blueprintjs/core";
import styled from "styled-components/macro";
import {
  makeAuthorizedGetRequestToBackend3,
  makeUrl,
} from "../../helpers/backendApi";
import { toaster } from "../../toaster";
import { useStoreActions } from "../../hooks/ep";

const handleFetchSentEmailContent = async ({
  emailId,
  setSentEmailContent,
}) => {
  try {
    const data = await makeAuthorizedGetRequestToBackend3({
      url: makeUrl(`sent_emails/${emailId}/content`),
    });
    setSentEmailContent(data);
  } catch (e) {
    setSentEmailContent(null);
    toaster.error("Something went wrong. Please reload and try again");
  }
};

export function SentEmailViewerButtonCellRenderer({
  value,
}: {
  value: number;
}) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const setSentEmailContent = useStoreActions(
    (a) => a.misc.setSentEmailContent
  );

  const emailId = value;
  const onClickFactory = useCallback(
    () => async () => {
      if (isLoading) {
        return;
      }
      setIsLoading(true);
      await handleFetchSentEmailContent({
        emailId: emailId,
        setSentEmailContent: setSentEmailContent,
      });
      setIsLoading(false);
    },
    // eslint-disable-next-line
    [emailId, handleFetchSentEmailContent]
  );

  const onClick = onClickFactory();
  return (
    <span key={emailId}>
      <Tooltip
        content={"View email content"}
        boundary="viewport"
        hoverOpenDelay={1000}
        hoverCloseDelay={0}
        isOpen={isLoading ? false : null}
      >
        <StyledTag
          fill={true}
          minimal={true}
          intent={isLoading ? "none" : "primary"}
          large={false}
          onClick={onClick}
          icon={
            isLoading ? (
              <Spinner size={Spinner.SIZE_SMALL} />
            ) : (
              "search-template"
            )
          }
          interactive={!isLoading}
          disabled={isLoading}
        />
      </Tooltip>
    </span>
  );
}

const StyledTag = styled(Tag)`
  font-size: 14px;
  height: 26px;
  & .bp3-icon,
  & .bp3-spinner {
    margin-right: 6px;
  }
`;
